import gluten from '../../assets/images/gluten.jpg'
export default function Disclaimer(){
  return (
    <div className="menu-print disclaim">
      <div className="mp-wrap">
        <p>*Warning: Consumption of undercooked meat, poultry, eggs, or seafood may increase the risk of food-borne illness. 
        Alert your server if you have special dietary requirements.</p>
        
        <div className="stamp"><img src={gluten} alt="Villaggio Grille Gluten Free Options" /> <p>Represents Gluten Free Menu Items </p></div>
        <p>** There will be a convenience fee added to all card payments.</p>
      </div>
    </div>
  )
}